import { getApiClient } from './ApiClient'

export const skuLocaleStateListPromise = () => {
  return getApiClient()
    .get('/sku-locale-states')
    .then(resp => resp.data)
}

export const skuLocaleStateBulkUpdatePromise = (states) => {
  return getApiClient()
    .put('/sku-locale-states', { body: { states } })
    .then(resp => resp.data)
}
